import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './select.style.scss';

const SelectEl = ({ options, setSelected, selectedOption, placeholder, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Пульсація показується тільки якщо нічого не вибрано і селект не відкритий
  const pulse = !selectedOption && !isOpen;

  return (
    <div className={`select-wrapper ${pulse ? 'pulse-red' : ''}`}>
      <Select
        className='select'
        classNamePrefix='select'
        options={options}
        isSearchable={false}
        placeholder={placeholder}
        value={selectedOption}
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => setIsOpen(false)}
        onChange={(val) => {
          setSelected(val.value);
          setIsOpen(false); // на всяк випадок
        }}
        {...props}
      />
    </div>
  );
};

SelectEl.propTypes = {
  options: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  selectedOption: PropTypes.object,
  placeholder: PropTypes.string.isRequired,
};

export default SelectEl;